import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#F1F5F9] border-t border-[#E2E8F0] pt-20 pb-8">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="/nvseeds-logo.png" 
                alt="Novaseeds Technologies" 
                className="h-24 md:h-32 w-auto"
              />
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed mb-4">
              Transforming ideas into powerful digital solutions. We build custom software that drives growth and innovation.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/novaseeds" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="w-10 h-10 rounded-lg bg-white border border-[#E2E8F0] hover:bg-slate-100 flex items-center justify-center transition-colors">
                <Linkedin size={18} className="text-slate-600" />
              </a>
              <a href="https://twitter.com/novaseeds" target="_blank" rel="noopener noreferrer" data-testid="footer-twitter" className="w-10 h-10 rounded-lg bg-white border border-[#E2E8F0] hover:bg-slate-100 flex items-center justify-center transition-colors">
                <Twitter size={18} className="text-slate-600" />
              </a>
              <a href="https://github.com/novaseeds" target="_blank" rel="noopener noreferrer" data-testid="footer-github" className="w-10 h-10 rounded-lg bg-white border border-[#E2E8F0] hover:bg-slate-100 flex items-center justify-center transition-colors">
                <Github size={18} className="text-slate-600" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-foreground font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/services" data-testid="footer-custom-software" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Custom Software Development</Link></li>
              <li><Link to="/services" data-testid="footer-web-dev" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Web App Development</Link></li>
              <li><Link to="/services" data-testid="footer-mobile-dev" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Mobile App Development</Link></li>
              <li><Link to="/services" data-testid="footer-saas-dev" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">SaaS Development</Link></li>
              <li><Link to="/hire-developers" data-testid="footer-hire-dev" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Hire Developers</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-foreground font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" data-testid="footer-about" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">About Us</Link></li>
              <li><Link to="/case-studies" data-testid="footer-case-studies" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Case Studies</Link></li>
              <li><Link to="/blog" data-testid="footer-blog" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Blog</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="text-muted-foreground hover:text-blue-600 text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-foreground font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-muted-foreground text-sm">
                <Mail size={18} className="mt-0.5 flex-shrink-0 text-slate-600" />
                <a href="mailto:sales@nvseeds.com" className="hover:text-blue-600 transition-colors">sales@nvseeds.com</a>
              </li>
              <li className="flex items-start space-x-3 text-muted-foreground text-sm">
                <Phone size={18} className="mt-0.5 flex-shrink-0 text-slate-600" />
                <a href="tel:+919203190441" className="hover:text-blue-600 transition-colors">+91-9203190441</a>
              </li>
              <li className="flex items-start space-x-3 text-muted-foreground text-sm">
                <MapPin size={18} className="mt-0.5 flex-shrink-0 text-slate-600" />
                <span>2nd floor, WeWork Eleven West, Pan Card Club Rd, Baner, Pune, Maharashtra 411069</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#E2E8F0] pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Novaseeds Technologies Pvt Ltd. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-muted-foreground hover:text-foreground text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-muted-foreground hover:text-foreground text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
